<div class="modal-body p-0 pb-4 mb-3 bg-animated">
    <button type="button" class="close" style="position:absolute;right:10px;top:3px;opacity:1;cursor:pointer;z-index:2;" aria-label="Close" (click)="close()">
        <span style="font-size:3rem;font-weight:300;" [ngStyle]="getCloseIconColor()" aria-hidden="true">&times;</span>
    </button>
    <app-ticket-redeem [eventTicket]="eventTicket" [service]="_ticketService" (redeemProcess)="redeemProcessStarted($event)"></app-ticket-redeem>
</div>
<div class="text-center modal-close-button">
    <button type="button" class="btn btn-light" aria-label="Close" style="min-width:150px;" (click)="close()">Close</button>
</div>
